<template>
    <div class="transaction-page">
        <mt-header class="dl_header_new_bg" fixed>
            <mt-button slot="left" @click.native="$router.back()">
                <img class="go-back" src="@/assets/img/ico_back.png" />
            </mt-button>
        </mt-header>
        <mt-loadmore bottomPullText="" :bottomDropText="$t('system.topDropText')" :bottomDistance="10" :maxDistance="50"
            :bottomLoadingText="$t('system.topLoadingText')" :bottom-method="loadBottom" :bottom-all-loaded="false"
            ref="loadmoreLocal" :autoFill="autoFill">
            <div class="container">
                <div class="page-head">
                    <img v-bind:src="img_url" alt class="oImg" />
                    <div>
                        <h2 class="page-title">{{ chain }} {{ chain != unit ? unit : '' }}</h2>
                        <div @click="copy($event, address)" class="page-address" v-if="address"> {{ fixNumber(address,
                                9)
                        }}
                            <img class="copy-svg" src="@/assets/img/copy.svg" />

                        </div>
                    </div>


                    <!--<img src="../../assets/img/coinDetail/ico_saoyisao_fasong.png" alt class="sao" />-->
                </div>
                <div class="asset-balance">
                    {{ balance }}
                </div>


                <div class="transactions-wrapper" v-if="transactions">
                    <div class="transaction" v-for="(transaction, index) in transactions" :key="index"
                        @click="getTransactionDetails(transaction)">
                        <div class="transaction-left">
                            <img v-if="transaction.to != address" class="go-back" src="@/assets/img/send.svg" />
                            <img v-else class="go-back" src="@/assets/img/receive.svg" />

                            <div>

                                <div class="to-address" v-if="address">
                                    {{ transaction.to != address ? fixNumber(transaction.to, 6) :
                                            fixNumber(transaction.from,
                                                6)
                                    }}

                                </div>
                                <div class="transaction-date">
                                    {{ secondToDate(transaction.timestamp) }}
                                </div>
                            </div>
                        </div>

                        <div class="transaction-right">
                            <div class="transaction-value" v-if="address"
                                :class="transaction.to != address ? 'transaction-value-minus' : 'transaction-value-plus'">
                                {{ transaction.to != address ? '-' : '+' }}{{ transaction.value }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div slot="bottom" class="mint-loadmore-bottom">
                <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }"></span>
                <span v-show="bottomStatus === 'loading'" class="mint-loadmore-bottom-onload">
                    <mt-spinner type="snake"></mt-spinner>
                </span>
            </div>
        </mt-loadmore>
        <TransactionDetails @closeDetails="isTransactionDetails = !isTransactionDetails" :details="txDetails"
            :walletAddress="address" v-if="isTransactionDetails"></TransactionDetails>
    </div>
</template>
<script>
import axios from 'axios'
import { getSingleBalance } from "@/api/hdassets"
import TransactionDetails from './TransactionDetails.vue'
import { secoendToDate, fixTheAddress } from "@/filters/index";
import handleClipboard from "@/utils/clipboard";
import { Toast } from "mint-ui";

export default {
    name: "transactions",
    data() {
        return {
            transactions: [],
            chain: null,
            address: null,
            contractAdress: null,
            type: null,
            unit: null,
            page: 1,
            offset: 10,
            img_url: null,
            balance: null,
            allLoaded: false,
            autoFill: false,
            bottomStatus: '',
            scrollHeight: 0,
            innerHeight: 0,
            scrollY: 0,
            interval: null,
            isTransactionDetails: false,
            txDetails: null,
        }
    },
    methods: {
        async getTransaction() {
            this.allLoaded = false

            this.bottomStatus = 'loading'
            this.address = this.$route.params.address
            this.chain = this.$route.query.chain
            this.type = this.$route.query.type
            this.contractAddress = this.$route.query.contractAddress

            this.unit = this.$route.query.unit
            this.img_url = window.getLocalCoinImg(this.unit)
            console.log(this.$route.query);

            let result = null
            if (this.type == 'main') {
                result = await axios({
                    url: `http://api.auwallet.io/api/wallet/txlist?chain=${this.chain}&address=${this.address}&page=${this.page}&offset=${this.offset}`,
                    method: 'get'
                })
            } else if (this.type == 'token') {
                result = await axios({
                    url: `http://api.auwallet.io/api/wallet/tokentx?chain=${this.chain}&address=${this.address}&page=${this.page}&offset=${this.offset}&contractAddress=${this.contractAddress}`
                    ,
                    method: 'get'
                })
            }

            if (result.status == 200 && result.data.data) {
                result.data.data.forEach(d => {
                    this.transactions.push(d)
                })
console.log(result)
                this.bottomStatus = ''

            }else {
                this.bottomStatus = ''

            }

            this.allLoaded = true
        },

        async getBalance() {
            if (this.$route.query.type == 'main') {
                this.balance = await getSingleBalance(this.$route.query.type, this.$route.query.chain, this.$route.params.address)

            } else {
                this.balance = await getSingleBalance(this.$route.query.type, this.$route.query.chain, this.$route.params.address, this.$route.query.contractAddress)

            }
        },
        fixNumber(number, l) {
            return fixTheAddress(number, l)
        },
        loadBottom() {
            if (this.allLoaded && this.ableToLoad) {
                if (this.transactions.length % this.offset == 0) {
                    this.page++
                    this.getTransaction()
                }

                this.$refs.loadmoreLocal.onBottomLoaded();
            }
        },

        getTransactionDetails(item) {
            this.isTransactionDetails = true
            this.txDetails = item
        },

        secondToDate(d) {
            return secoendToDate(d)
        },

        copy: function (event, val) {
            handleClipboard(
                val,
                event,
                () => {
                    Toast(this.$t("fuzhicg"));
                },
                () => {
                    Toast(this.$t("fuzhicc"));
                }
            );
        }

    },

    mounted() {
        this.getTransaction()
        this.getBalance()
        this.interval = setInterval(() => {
            this.scrollHeight = document.body.scrollHeight;
            this.innerHeight = window.innerHeight
            this.scrollY = window.scrollY
        }, 100);
    },

    destroyed() {
        clearInterval(this.interval);
    },

    watch: {
        scrollHeight() {
            // this will called when the polling changes the value
            console.log(this.scrollHeight);
        }
    },

    computed: {

        ableToLoad() {
            if (this.scrollY > ((this.transactions.length - 10) * 50)) return true
            else return false
        }

    },
    components: {
        TransactionDetails, Toast
    }


}
</script>

<style scoped>
.transaction-page {
    width: 100%;
    height: fit-content;
    background-color: #f6f8fa;
    padding-top: 50px !important;
}

.oImg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.page-head {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #ffffff;

}

.page-title {
    font-size: 1.25rem;
    color: #12172e;
}

.page-address {
    color: gray;
}

.container {}

.go-back {
    width: 20px;
    height: 20px;
}

.asset-balance {
    display: flex;
    justify-content: flex-end;
    font-weight: bold;
    color: rgb(8, 22, 44);
    background: white;
    margin-bottom: 24px;
    padding: 8px 12px;

}


.transaction-page /deep/ .mint-button--normal {
    padding: 0 !important;
}

.transactions-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #ffffff;

}

.transaction {
    display: flex;
    height: 50px;
    align-items: center;
    padding: 0 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.to-address {
    font-weight: bold;
    color: #242d53;

}

.transaction-date {
    font-size: 0.75rem;
    color: gray;
}

.transaction-left {
    display: flex;
}

.transaction-right {
    display: flex;
    margin-left: auto;
}

.transaction-value {
    font-size: 0.875rem;
    font-weight: bold;

}

.transaction-value-plus {
    color: #2BB0E9;
}

.transaction-value-minus {
    color: #FF7371;
}

.transaction-page /deep/ .mint-loadmore-bottom-onload {
    position: fixed;
    bottom: 0;
    z-index: 1000;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    background: transparent;
    padding: 8px;
    color: gray !important;
}

.copy-svg {
    filter: invert(100%) sepia(0%) saturate(1168%) hue-rotate(267deg) brightness(122%) contrast(50%);
    width: 15px;
    height: 15px;
}
</style>